import { render, staticRenderFns } from "./ActivePageSettings.vue?vue&type=template&id=ea609834"
import script from "./ActivePageSettings.vue?vue&type=script&lang=js"
export * from "./ActivePageSettings.vue?vue&type=script&lang=js"
import style0 from "./ActivePageSettings.vue?vue&type=style&index=0&id=ea609834&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports